import de from './de.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };

export const reportingI18nNamespace = 'reporting' as const;
export const reportingResources = { de, en } as const;
